import React from 'react';
import { Divider } from '../../../components';
import { ReplaceProductScreenContent } from './replace-product-screen-content';
import {
  AddLineItems,
  dispatch,
  getSearchKey,
  ProductVariant,
  removeSearchKey,
  updateSearchKey,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { SwipeableDrawer, Box } from '@mui/material';
import { TouchableOpacity } from '../../../common';
import { ReactComponent as SearchIcon } from '@zonofi/svg-icons/search-icon.svg';
import { DividerColorVariant } from '../../../constants';
import './replace-product-drawer.scss';

export const ReplaceProductDrawer: React.FC<{
  open: boolean;
  onClose: () => void;
  lineItems?: AddLineItems[];
  onReplaceProduct?: (product: ProductVariant) => void;
}> = ({ open, onClose, lineItems, onReplaceProduct }) => {
  const searchKey = useAppSelector(getSearchKey);

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableSwipeToOpen
      PaperProps={{
        className: 'replace-product-modal-view',
        style: { height: '92vh' },
      }}
    >
      <Box className="replace-product-modal-container">
        <div className="replace-product-modal__header">
          <span className="replace-product-modal__header-text font-semibold">
            {'Select Product'}
          </span>

          <TouchableOpacity
            onPress={() => {
              dispatch(removeSearchKey());
              onClose();
            }}
          >
            <span className="replace-product-modal__header-text close-text font-semibold">
              {'Close'}
            </span>
          </TouchableOpacity>
        </div>

        <div className="replace-product-modal__search">
          <SearchIcon />
          <div className="replace-product-modal__search-divider" />
          <input
            type="text"
            placeholder={'Search Product'}
            className="replace-product-modal__search-input"
            onChange={(e) => dispatch(updateSearchKey(e.target.value))}
            value={searchKey}
          />
        </div>

        <Divider colorVariant={DividerColorVariant.DEFAULT} />

        <ReplaceProductScreenContent
          onClose={onClose}
          lineItems={lineItems}
          onReplaceProduct={onReplaceProduct}
        />
      </Box>
    </SwipeableDrawer>
  );
};
